import styled from 'styled-components';
import HomeSidePanel from '@/components/HomeSidePanel/HomeSidePanel.container';
import SearchInputComponent from '@/components/SearchInput';
import TopPageLinks from '@/components/TopPageLinks';
import { media } from '@/styles/responsive';

export const SidePanel = styled(HomeSidePanel)`
  position: fixed;
  left: 0;
  top: 56px;
  height: calc(100vh - 56px);

  ${media.mobile} {
    display: none;
  }
`;

export const PageContent = styled.div`
  margin-left: 300px;

  ${media.mobile} {
    margin-left: 0;
  }
`;

export const HeaderContainer = styled.div`
  padding-top: 16px;
  padding-left: 26px;
  padding-right: 32px;
  padding-bottom: 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors['neutral-30']};
  background-color: ${({ theme }) => theme.colors['neutral-20']};
  position: sticky;
  top: 0;
  z-index: 4;

  ${media.mobile} {
    padding: 12px 16px;
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
`;

export const HeaderLinks = styled(TopPageLinks)`
  flex-grow: 1;
`;

export const SearchInput = styled(SearchInputComponent)`
  width: 260px;

  ${media.mobile} {
    width: 100%;
  }
`;

export const BodyContainer = styled.div`
  padding-top: 32px;
  padding-left: 38px;
  padding-right: 32px;

  ${media.mobile} {
    padding: 16px;
  }
`;

export const Box = styled.div`
  display: flex;
  justify-content: center;
  height: calc(100vh - 56px);
`;
